import { render } from "./Dropdown4.vue?vue&type=template&id=fa7e60b6&ts=true"
import script from "./Dropdown4.vue?vue&type=script&lang=ts"
export * from "./Dropdown4.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\bridge\\bridgeshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__